import {
  Box,
  Button,
  Card,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { H5 } from 'components/Typography';

const PaymentMethodCard = ({ ...props }) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // Sample payment method data
  const paymentMethods = [
    {
      id: 1,
      type: 'VISA',
      cardNumber: '**** 1234',
      expiryDate: '12/26',
    },
  ];

  const handleChangePayment = paymentId => {
    console.log('Change payment method:', paymentId);
    // Add your payment change logic here
  };

  const handleDeletePayment = paymentId => {
    console.log('Delete payment method:', paymentId);
    // Add your payment deletion logic here
  };

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    backgroundColor: theme.palette.primary.lightGrey200,
    borderRadius: 0,
    border: 'none',
  }));

  const PaymentMethodItem = styled(Box)(({ theme }) => ({
    backgroundColor: '#F8F8F8',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '16px',
    },
  }));

  const PaymentInfo = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '12px',
    },
  }));

  const VisaLogo = styled(Box)(({ theme }) => ({
    width: '64px',
    height: '40px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  }));

  const CardDetails = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  }));

  const CardNumber = styled(Box)(({ theme }) => ({
    fontSize: '16px',
    fontWeight: '500',
    color: '#1F2937',
    lineHeight: '1.4',
  }));

  const ExpiryDate = styled(Box)(({ theme }) => ({
    fontSize: '14px',
    color: '#6B7280',
    fontWeight: '400',
  }));

  const ActionButtons = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: '8px',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-end',
    },
  }));

  const ChangeButton = styled(Button)(({ theme }) => ({
    backgroundColor: '#3B82F6',
    color: '#FFFFFF',
    borderRadius: '8px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'none',
    minWidth: '60px',
    '&:hover': {
      backgroundColor: '#2563EB',
    },
  }));

  const DeleteButton = styled(Button)(({ theme }) => ({
    backgroundColor: '#E5E7EB',
    color: '#6B7280',
    borderRadius: '8px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'none',
    minWidth: '60px',
    '&:hover': {
      backgroundColor: '#D1D5DB',
    },
  }));

  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: '#fff',
            padding: isTablet ? '18px' : '26px',
            borderRadius: '24px',
            boxShadow: '1px 4px 6px rgba(0, 0, 0, 0.05)',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Title */}
          <Box
            sx={{
              marginBottom: '24px',
            }}
          >
            <H5
              sx={{
                fontWeight: 'bold',
                lineHeight: 1.3,
                fontSize: isTablet ? '16px' : '18px',
                color: '#1F2937',
              }}
            >
              결제 수단
            </H5>
          </Box>

          {/* Payment Methods */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              flex: 1,
            }}
          >
            {paymentMethods.map(payment => (
              <PaymentMethodItem key={payment.id}>
                <PaymentInfo>
                  <VisaLogo>
                    <img src="/static/logo/visa.png" alt="VISA" />
                  </VisaLogo>
                  <CardDetails>
                    <CardNumber>
                      {payment.type} 카드 ({payment.cardNumber})
                    </CardNumber>
                    <ExpiryDate>만료일: {payment.expiryDate}</ExpiryDate>
                  </CardDetails>
                </PaymentInfo>

                <ActionButtons>
                  <ChangeButton onClick={() => handleChangePayment(payment.id)}>
                    변경
                  </ChangeButton>
                  <DeleteButton onClick={() => handleDeletePayment(payment.id)}>
                    삭제
                  </DeleteButton>
                </ActionButtons>
              </PaymentMethodItem>
            ))}
          </Box>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default PaymentMethodCard;
